export default __webpack_public_path__ + "static/media/ktb.7b141c56.svg";